import React, { Suspense } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Toast } from './components/common/Toast';
import Home from './pages/HomePage.jsx';
import Login from './pages/Users/Login.jsx';
import ProfileUpload from './pages/Users/ProfileUpload.jsx';
import VerifyProfile from './pages/Users/VerifyProfile.jsx';
import HobbiesInterests from './pages/Users/HobbiesInterests.jsx';
import IntroModal from './components/common/IntroModel.js';
import FamilyDetailsForm from './pages/Users/FamilyDetailsForm.jsx';
import PartnerPreferences from './pages/Users/PartnerPreferences.jsx';
import FamilyPlanningGoal from './pages/Users/FamilyPlanningGoal.jsx'; // NEW — Phase 4 goal step, adjust path to wherever you save it
import DoctorDashboard from './components/Dashboard/Doctor/Doctordashboard.jsx';
import DashboardPage from './components/Dashboard/dashboard/DashboardPage.jsx';
import ForgotPasswordOTP from './pages/Users/forget-password/ForgotPasswordOTP.jsx';
import Matches from './components/Dashboard/Matches/Matches.jsx';
import Search from './components/Dashboard/search/Search.jsx';
import MessageInbox from './components/Dashboard/inboxmessage/MessageInbox.jsx';
import SearchResultsPage from './components/Dashboard/search/SearchResultsPage.jsx';
import Inbox from './components/Dashboard/inbox/Inbox.jsx';
import Health from './components/Dashboard/Health/Health.jsx';
import Continuouscare from './components/Dashboard/ContinousCare/Continuouscare.jsx';
import Appointment from './components/Dashboard/Appointment/Appointment.jsx';
import Meeting from './components/Dashboard/Meeting/Meeting.jsx';
import OnboardingLayout from './components/Layout/OnboardingLayout';
import DashboardLayout from './components/Layout/DashboardLayout';
import GeneticBiological from './components/Dashboard/dna/components/Biological.jsx';
import GeneticPhyscological from './components/Dashboard/dna/components/Psycholigical.jsx';
import GeneticBirthDefect from './components/Dashboard/dna/components/BirthDefect.jsx';
import IdentityEnrichment from './components/Dashboard/IdentityEnrichment/IdentityEnrichment.jsx';
import UpgradeProfile from './components/UpgradeProfile/UpgradeProfile.jsx';
import PaymentSuccess from './components/UpgradeProfile/Success.jsx';
import PaymentCancel from './components/UpgradeProfile/Cancel.jsx';
import ScrollToTop from './components/common/ScrollToTop';
import ProfilePage from './components/Dashboard/Matches/components/ProfilePage.jsx';

import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import VerifyEmail from './pages/Users/VerifyEmail.jsx'; // NEW — handles the emailed verification link, adjust path to wherever you save it
import TermsAndConditions from './pages/TermOfService.jsx';
import ContactUs from './pages/ContactUs.jsx';
import DeletePage from './pages/DeletePage.jsx';
import SocialAuthSuccess from './components/Dashboard/dashboard/dashtabcomponents/SocialAuthSuccess.jsx';
import SocialAuthError from './components/Dashboard/dashboard/dashtabcomponents/SocialAuthError.jsx';
import AboutPage from './pages/AboutPage';
import FamilyPlanningCarrierScreeningCostPage from './pages/FamilyPlanningCarrierScreeningCostPage';
import FamilyPlanningCarrierScreeningExistingResultsPage from './pages/FamilyPlanningCarrierScreeningExistingResultsPage';
import FamilyPlanningCarrierScreeningPage from './pages/FamilyPlanningCarrierScreeningPage';
import FamilyPlanningCysticFibrosisCarrierScreeningPage from './pages/FamilyPlanningCysticFibrosisCarrierScreeningPage';
import FamilyPlanningGeneticCounselingBeforePregnancyPage from './pages/FamilyPlanningGeneticCounselingBeforePregnancyPage';
import FamilyPlanningWhatIsCarrierScreeningPage from './pages/FamilyPlanningWhatIsCarrierScreeningPage';
import FaqPage from './pages/FaqPage';
import FertilityCanadaIvfWellnessSupportPage from './pages/FertilityCanadaIvfWellnessSupportPage';
import FertilityEggDonorFamilyPlanningPage from './pages/FertilityEggDonorFamilyPlanningPage';
import FertilityFertilityAppForCouplesPage from './pages/FertilityFertilityAppForCouplesPage';
import FertilityIvfBloodPressureMonitoringPage from './pages/FertilityIvfBloodPressureMonitoringPage';
import FertilityIvfPreparationPage from './pages/FertilityIvfPreparationPage';
import FertilityPreconceptionWellnessTrackingPage from './pages/FertilityPreconceptionWellnessTrackingPage';
import HowItWorksPage from './pages/HowItWorksPage';
import MonitoringBloodPressureChartPregnancyTrimesterPage from './pages/MonitoringBloodPressureChartPregnancyTrimesterPage';
import MonitoringBloodPressurePregnancyPage from './pages/MonitoringBloodPressurePregnancyPage';
import MonitoringGestationalHypertensionSymptomsPage from './pages/MonitoringGestationalHypertensionSymptomsPage';
import MonitoringHomeBloodPressureCuffPregnancyPage from './pages/MonitoringHomeBloodPressureCuffPregnancyPage';
import MonitoringPreeclampsiaWarningSignsPage from './pages/MonitoringPreeclampsiaWarningSignsPage';
import MonitoringWhenToCallDoctorBloodPressurePregnancyPage from './pages/MonitoringWhenToCallDoctorBloodPressurePregnancyPage';
import PartnersDirectoryPage from './pages/PartnersDirectoryPage';
import PartnersFindAProviderPage from './pages/PartnersFindAProviderPage';
import PartnersIvfClinicPartnershipPage from './pages/PartnersIvfClinicPartnershipPage';
import PartnersJoinReferralNetworkPage from './pages/PartnersJoinReferralNetworkPage';
import PartnersNoFeeDirectoryFaqPage from './pages/PartnersNoFeeDirectoryFaqPage';
import PartnersPage from './pages/PartnersPage';
import PartnersSurrogacyAgencyPartnershipPage from './pages/PartnersSurrogacyAgencyPartnershipPage';
import PostpartumBloodPressureAfterPregnancyPage from './pages/PostpartumBloodPressureAfterPregnancyPage';
import PostpartumCardiovascularRiskAfterPreeclampsiaPage from './pages/PostpartumCardiovascularRiskAfterPreeclampsiaPage';
import PostpartumLongTermHealthPage from './pages/PostpartumLongTermHealthPage';
import PostpartumLongTermHypertensionPregnancyHistoryPage from './pages/PostpartumLongTermHypertensionPregnancyHistoryPage';
import PostpartumPostpartumMonitoringTimelinePage from './pages/PostpartumPostpartumMonitoringTimelinePage';
import PostpartumPostpartumPreeclampsiaSymptomsPage from './pages/PostpartumPostpartumPreeclampsiaSymptomsPage';
import PregnancyMonitoringPage from './pages/PregnancyMonitoringPage';
import PricingPage from './pages/PricingPage';
import PrivacySafetyPage from './pages/PrivacySafetyPage';
import ProvidersClinicalProtocolAcogSmfmPage from './pages/ProvidersClinicalProtocolAcogSmfmPage';
import ProvidersEmrIntegrationPage from './pages/ProvidersEmrIntegrationPage';
import ProvidersEmrSystemsSupportedPage from './pages/ProvidersEmrSystemsSupportedPage';
import ProvidersEpicIntegrationPatientGeneratedDataPage from './pages/ProvidersEpicIntegrationPatientGeneratedDataPage';
import ProvidersHowToRecommendFutureFamilyPage from './pages/ProvidersHowToRecommendFutureFamilyPage';
import ProvidersPage from './pages/ProvidersPage';
import ProvidersPhysicianDashboardPregnancyMonitoringPage from './pages/ProvidersPhysicianDashboardPregnancyMonitoringPage';
import SurrogacyCoordinatorRoleWellnessAppPage from './pages/SurrogacyCoordinatorRoleWellnessAppPage';
import SurrogacyIndependentSurrogateAgenciesPage from './pages/SurrogacyIndependentSurrogateAgenciesPage';
import SurrogacyIntendedParentUpdatesPage from './pages/SurrogacyIntendedParentUpdatesPage';
import SurrogacySurrogateBloodPressureTrackingPage from './pages/SurrogacySurrogateBloodPressureTrackingPage';
import SurrogacySurrogateHealthMonitoringAppPage from './pages/SurrogacySurrogateHealthMonitoringAppPage';
import SurrogacyWellnessMonitoringPage from './pages/SurrogacyWellnessMonitoringPage';

// 🔧 NEW — doctor auth
import DoctorLogin from './pages/Doctor/Login.jsx';
import ProtectedDoctorRoute from './pages/Doctor/ProtectedDoctorRoute';

import { ServiceProvider } from './context/ServiceContext.js';

// Protected Route Wrapper for Onboarding routes
const OnboardingRoute = () => {
  const { token } = useSelector((state) => state.user);
  return token ? (
    <OnboardingLayout>
      <Outlet />
    </OnboardingLayout>
  ) : (
    <Navigate to="/login" replace />
  );
};

// Protected Route Wrapper for Dashboard routes
// Protected Route Wrapper for Dashboard routes
//
// Guards against two things now, not just missing auth: an unauthenticated
// user (token check, as before), AND an authenticated-but-not-yet-onboarded
// user reaching the dashboard by any path other than the post-login
// redirect in Login.jsx (browser back button, a bookmark, refreshing
// mid-onboarding-chain, etc.). userInfo.onboarding_completed comes from
// the same users.* row Login.jsx's response already carries, and Redux
// persists it, so this is a synchronous check — no extra API call needed
// on every navigation.
const DashboardRoute = () => {
  const { token, userInfo } = useSelector((state) => state.user);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (userInfo && !userInfo.onboarding_completed) {
    return <Navigate to="/family-planning-goal" replace />;
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};
const DoctorRoute = () => {
  const { token } = useSelector((state) => state.doctor);
  return token ? <Outlet /> : <Navigate to="/doctor/login" replace />;
};

function App() {
  return (
    <ServiceProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <Toast />
        <ScrollToTop />
        <IntroModal />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forget-password" element={<ForgotPasswordOTP />} />
          <Route path="/social-auth-callback" element={<SocialAuthSuccess />} />
          <Route path="/social-auth-error" element={<SocialAuthError />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/delete-account" element={<DeletePage />} />
          <Route path="/verify-email" element={<VerifyEmail />} />



          {/* Static Pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/family-planning/carrier-screening" element={<FamilyPlanningCarrierScreeningPage />} />
          <Route path="/family-planning/carrier-screening-cost" element={<FamilyPlanningCarrierScreeningCostPage />} />
          <Route path="/family-planning/carrier-screening-existing-results" element={<FamilyPlanningCarrierScreeningExistingResultsPage />} />
          <Route path="/family-planning/cystic-fibrosis-carrier-screening" element={<FamilyPlanningCysticFibrosisCarrierScreeningPage />} />
          <Route path="/family-planning/genetic-counseling-before-pregnancy" element={<FamilyPlanningGeneticCounselingBeforePregnancyPage />} />
          <Route path="/family-planning/what-is-carrier-screening" element={<FamilyPlanningWhatIsCarrierScreeningPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/fertility/canada-ivf-wellness-support" element={<FertilityCanadaIvfWellnessSupportPage />} />
          <Route path="/fertility/egg-donor-family-planning" element={<FertilityEggDonorFamilyPlanningPage />} />
          <Route path="/fertility/fertility-app-for-couples" element={<FertilityFertilityAppForCouplesPage />} />
          <Route path="/fertility/ivf-blood-pressure-monitoring" element={<FertilityIvfBloodPressureMonitoringPage />} />
          <Route path="/fertility/ivf-preparation" element={<FertilityIvfPreparationPage />} />
          <Route path="/fertility/preconception-wellness-tracking" element={<FertilityPreconceptionWellnessTrackingPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/monitoring/blood-pressure-chart-pregnancy-trimester" element={<MonitoringBloodPressureChartPregnancyTrimesterPage />} />
          <Route path="/monitoring/blood-pressure-pregnancy" element={<MonitoringBloodPressurePregnancyPage />} />
          <Route path="/monitoring/gestational-hypertension-symptoms" element={<MonitoringGestationalHypertensionSymptomsPage />} />
          <Route path="/monitoring/home-blood-pressure-cuff-pregnancy" element={<MonitoringHomeBloodPressureCuffPregnancyPage />} />
          <Route path="/monitoring/preeclampsia-warning-signs" element={<MonitoringPreeclampsiaWarningSignsPage />} />
          <Route path="/monitoring/when-to-call-doctor-blood-pressure-pregnancy" element={<MonitoringWhenToCallDoctorBloodPressurePregnancyPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/partners/directory" element={<PartnersDirectoryPage />} />
          <Route path="/partners/find-a-provider" element={<PartnersFindAProviderPage />} />
          <Route path="/partners/ivf-clinic-partnership" element={<PartnersIvfClinicPartnershipPage />} />
          <Route path="/partners/join-referral-network" element={<PartnersJoinReferralNetworkPage />} />
          <Route path="/partners/no-fee-directory-faq" element={<PartnersNoFeeDirectoryFaqPage />} />
          <Route path="/partners/surrogacy-agency-partnership" element={<PartnersSurrogacyAgencyPartnershipPage />} />
          <Route path="/postpartum/blood-pressure-after-pregnancy" element={<PostpartumBloodPressureAfterPregnancyPage />} />
          <Route path="/postpartum/cardiovascular-risk-after-preeclampsia" element={<PostpartumCardiovascularRiskAfterPreeclampsiaPage />} />
          <Route path="/postpartum/long-term-health" element={<PostpartumLongTermHealthPage />} />
          <Route path="/postpartum/long-term-hypertension-pregnancy-history" element={<PostpartumLongTermHypertensionPregnancyHistoryPage />} />
          <Route path="/postpartum/postpartum-monitoring-timeline" element={<PostpartumPostpartumMonitoringTimelinePage />} />
          <Route path="/postpartum/postpartum-preeclampsia-symptoms" element={<PostpartumPostpartumPreeclampsiaSymptomsPage />} />
          <Route path="/pregnancy-monitoring" element={<PregnancyMonitoringPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy-safety" element={<PrivacySafetyPage />} />
          <Route path="/providers" element={<ProvidersPage />} />
          <Route path="/providers/clinical-protocol-acog-smfm" element={<ProvidersClinicalProtocolAcogSmfmPage />} />
          <Route path="/providers/emr-integration" element={<ProvidersEmrIntegrationPage />} />
          <Route path="/providers/emr-systems-supported" element={<ProvidersEmrSystemsSupportedPage />} />
          <Route path="/providers/epic-integration-patient-generated-data" element={<ProvidersEpicIntegrationPatientGeneratedDataPage />} />
          <Route path="/providers/how-to-recommend-future-family" element={<ProvidersHowToRecommendFutureFamilyPage />} />
          <Route path="/providers/physician-dashboard-pregnancy-monitoring" element={<ProvidersPhysicianDashboardPregnancyMonitoringPage />} />
          <Route path="/surrogacy/coordinator-role-wellness-app" element={<SurrogacyCoordinatorRoleWellnessAppPage />} />
          <Route path="/surrogacy/independent-surrogate-agencies" element={<SurrogacyIndependentSurrogateAgenciesPage />} />
          <Route path="/surrogacy/intended-parent-updates" element={<SurrogacyIntendedParentUpdatesPage />} />
          <Route path="/surrogacy/surrogate-blood-pressure-tracking" element={<SurrogacySurrogateBloodPressureTrackingPage />} />
          <Route path="/surrogacy/surrogate-health-monitoring-app" element={<SurrogacySurrogateHealthMonitoringAppPage />} />
          <Route path="/surrogacy/wellness-monitoring" element={<SurrogacyWellnessMonitoringPage />} />


          {/* 🔧 NEW — Doctor login is public, same as patient /login */}
          <Route path="/doctor/login" element={<DoctorLogin />} />

          {/* Protected Routes */}
          {/* Onboarding Routes (with HeaderOnboarding) */}
          <Route element={<OnboardingRoute />}>
            <Route path="/profile-upload" element={<ProfileUpload />} />
            {/* <Route path="/hobbies" element={<HobbiesInterests />} /> */}
            <Route path="/verify-profile" element={<VerifyProfile />} />
            <Route path="/family-details" element={<FamilyDetailsForm />} />
            {/* <Route path="/partner-preferences" element={<PartnerPreferences />} /> */}
            {/* NEW — Phase 4, Step 2: family planning goal. Slotted in as
                the last onboarding step; if your existing chain currently
                ends by navigating away from /partner-preferences, update
                that component's navigate() call to point here instead. */}
            <Route path="/family-planning-goal" element={<FamilyPlanningGoal />} />
          </Route>

          {/* Dashboard Routes (with HeaderDashboard) — patient/member only */}
          <Route element={<DashboardRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/message-inbox" element={<MessageInbox />} />
            <Route path="/matches" element={<Matches />} />
            <Route path="/search-profile" element={<Search />} />
            <Route path="/search-results" element={<SearchResultsPage />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/health" element={<Health />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/continuouscare" element={<Continuouscare />} />
            <Route path="/meeting" element={<Meeting />} />
            <Route path="/gentics-biological-attraction" element={<GeneticBiological />} />
            <Route path="/gentics-psychological-compatibility" element={<GeneticPhyscological />} />
            <Route path="/gentics-birth-defect-risk" element={<GeneticBirthDefect />} />
            <Route path="/identity-enrichment" element={<IdentityEnrichment />} />
            <Route path="/upgrade-profile" element={<UpgradeProfile />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/profile/:profileId" element={<ProfilePage />} />
          </Route>

          {/* 🔧 FIXED — Doctor dashboard now guarded by DoctorRoute (checks
              state.doctor.token), not the patient DashboardRoute above.
              It was previously inside the patient block, which meant a
              doctor session could never satisfy it. */}
          <Route
            path="/doctor/dashboard"
            element={
              <ProtectedDoctorRoute>
                <DoctorDashboard />
              </ProtectedDoctorRoute>
            }
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </ServiceProvider>
  );
}

export default App;